import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";

import {Mail} from "../../../../classes/mail";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
    selector: 'kan-mail-preview-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanMailPreviewDialog {
    public mail: Mail;
    public body: SafeHtml;

    constructor(private dialogRef: MatDialogRef<kanMailPreviewDialog>,
                private sanitizer: DomSanitizer,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        if (this.data && this.data.mail) {
            this.mail = this.data.mail;
            this.body = this.sanitizer.bypassSecurityTrustHtml(this.mail.body);
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/mails/dialogs/mail-preview-dialog/component.ts